// see https://docs.aws.amazon.com/cognito-user-identity-pools/latest/APIReference/API_ResendConfirmationCode.html#API_ResendConfirmationCode_Errors

const ERRORS = [
  {
    code: 'CodeDeliveryFailureException',
    msg: 'Der Verifikationscode konnte nicht zugestellt werden.',
  },
  {
    code: 'InternalErrorException',
    msg: 'Interner AWS Cognito Fehler.',
  },
  {
    code: 'InvalidEmailRoleAccessPolicyException',
    msg: 'AWS Cognito darf deine E-Mail nicht verwenden.',
  },
  {
    code: 'InvalidLambdaResponseException',
    msg: 'Interner AWS Lambda Fehler.',
  },
  {
    code: 'InvalidParameterException',
    msg: 'Ungültiger Parameter.',
  },
  {
    code: 'InvalidSmsRoleAccessPolicyException',
    msg: 'Die Rolle zur SMS Konfiguration hat unzureichende AWS SNS Berechtigungen.',
  },
  {
    code: 'InvalidSmsRoleTrustRelationshipException',
    msg: 'Die SMS Konfiguration hat eine ungültige Vertrauensstellung.',
  },
  {
    code: 'LimitExceededException',
    msg: 'Deine Aktion hat das zulässige Limit überschritten. Versuche es später erneut.',
  },
  {
    code: 'NotAuthorizedException',
    msg: 'Du hast nicht die Berechtigung diese Aktion auszuführen.',
  },
  {
    code: 'ResourceNotFoundException',
    msg: 'Die Resource wurde nicht gefunden.',
  },
  {
    code: 'TooManyRequestsException',
    msg: 'Deine Aktion hat das zulässige Limit überschritten. Versuche es später erneut.',
  },
  {
    code: 'UnexpectedLambdaException',
    msg: 'Interner AWS Lambda Fehler.',
  },
  {
    code: 'UserLambdaValidationException',
    msg: 'User Validierungsfehler.',
  },
  {
    code: 'UserNotFoundException',
    msg: 'Falscher Benutzername.',
  },
]

export {ERRORS}
